// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subtitlesWidgetSaving{
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    gap: 10px;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    padding-top: 5px;
}

.subtitlesWidgetSaving_save{
    background-color: #FFA825;
    padding: 2px 10px;
    border-radius: 12px;
    color: #fff;
}

.subtitlesWidgetSaving_progress{

}
`, "",{"version":3,"sources":["webpack://./src/pages/meetingPage/components/subtitlesWidget/SubtitlesWidgetSaving.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;;AAEA","sourcesContent":[".subtitlesWidgetSaving{\n    display: flex;\n    align-items: center;\n    flex-direction: row-reverse;\n    gap: 10px;\n    font-weight: 400;\n    font-size: 10px;\n    line-height: 12px;\n    padding-top: 5px;\n}\n\n.subtitlesWidgetSaving_save{\n    background-color: #FFA825;\n    padding: 2px 10px;\n    border-radius: 12px;\n    color: #fff;\n}\n\n.subtitlesWidgetSaving_progress{\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
